import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Column } from '../..'
import colors from '../../../constants/colors'

export const FilterColumn = styled(Column)`
    background: ${colors.greylighter};
    border-right: 1px solid ${colors.greylight};
    padding-bottom: 10px;
`

export const FilterGroupLabel = styled.div`
    color: ${colors.greydark};
    font-weight: bold;
    margin: 15px 0 5px;
    padding-left: 30px;
    text-transform: uppercase;
`

export const FilterGroup = styled.ul`
    margin: 0;
    padding: 0;
    padding-left: 30px;
`

export const ButtonLabel = styled.span`
    margin-left: 10px;
`

export const FilterItem = styled.li`
    color: ${colors.greydark};
    cursor: pointer;
    display: block;
    margin-bottom: 1px;

    &:hover {
        color: ${colors.bluelight};
    }

    &:last-child {
        margin-bottom: 0;
    }
`

export const CellStatus = styled.div`
    text-align: left;
    text-decoration: none;
    ${({ header }) => !header && 'text-transform: capitalize;'}
    ${({ status }) => {
        switch (status ? status.toString() : null) {
            case '3':
                return 'color: #3672B8;'
            case '4':
                return 'color: #B3B3B3;'
            case '6':
                return 'color: #008000;'
            case '1':
                return 'color: #9A9A03;'
            case '2':
            default:
                return ''
        }
    }}
`

CellStatus.propTypes = {
    status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

CellStatus.defaultProps = {
    status: null,
}

export const CellDate = styled.div`
    width: 100px;
`

export const ActionGroup = styled.div`
    opacity: 0;
    transform: translateX(100%);
    transition: all 0.2s;

    *:hover > * > & {
        opacity: 1;
        transform: translateX(0);
    }
`

export const CellActions = styled(Link)`
    color: ${colors.blue};
    font-size: 14px;
    float: right;
    width: 100%;
    text-align: right;
    text-decoration: none;
`

export const IconButton = styled(FontAwesomeIcon)`
    color: ${colors.green};
    margin-left: 10px;
`
